import { LogLevel, type Configuration } from '@azure/msal-browser';

// M365 corporate tenant configuration.
// IMPORTANT: uses login.microsoftonline.com, NOT ciamlogin.com (B2C).
const CLIENT_ID = import.meta.env.VITE_DASH_CLIENT_ID || '';
const TENANT_ID = import.meta.env.VITE_DASH_TENANT_ID || 'fa14cebd-095b-4a9d-b7de-75d393ceb764';
const AUTHORITY = `https://login.microsoftonline.com/${TENANT_ID}`;

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    // M365 tenants use login.microsoftonline.com, NOT ciamlogin.com.
    knownAuthorities: ['login.microsoftonline.com'],
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

/** Interactive sign-in request. */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

/**
 * Token request for calling the status API. Defaults to the app's own
 * `.default` scope (api://<clientId>/.default). Override via VITE_DASH_API_SCOPE
 * if the app exposes a different Application ID URI (e.g. the bare GUID form).
 */
const API_SCOPE = import.meta.env.VITE_DASH_API_SCOPE || `api://${CLIENT_ID}/.default`;
export const apiRequest = {
  scopes: [API_SCOPE],
};

/** Status API location. Relative `/api` is routed to func-bva-health by Front Door. */
export const apiConfig = {
  baseUrl: import.meta.env.VITE_DASH_API_URL || '/api',
};
